import { AdminLayout } from '@/app/components/AdminLayout';
import { PageHeader, PageLoading } from '@/app/components/shared';
import { AppointmentsFilter, AppointmentsTable } from './components';
import { useAppointmentsData } from './hooks';

export function AppointmentsPage() {
  const {
    isLoading,
    appointments,
    paginationMeta,
    setPage,
    limit,
    setLimit,
    statuses,
    statusFilter,
    setStatusFilter,
    dateFrom,
    dateTo,
    setDateFrom,
    setDateTo,
    search,
    setSearch,
    showStoreFilter,
    availableStores,
    storeFilter,
    setStoreFilter,
    sortBy,
    sortOrder,
    handleSortChange,
    handleStatusChange,
    handleExport,
  } = useAppointmentsData();

  if (isLoading) {
    return <PageLoading message="Carregando agendamentos..." />;
  }

  return (
    <AdminLayout>
      <div className="space-y-4">
        <PageHeader title="Gerenciar Agendamentos" />

        <AppointmentsFilter
          dateFrom={dateFrom}
          dateTo={dateTo}
          statusFilter={statusFilter}
          search={search}
          statuses={statuses}
          showStoreFilter={showStoreFilter}
          availableStores={availableStores}
          storeFilter={storeFilter}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onStatusFilterChange={setStatusFilter}
          onSearchChange={setSearch}
          onStoreFilterChange={setStoreFilter}
          onExport={handleExport}
        />

        <AppointmentsTable
          appointments={appointments}
          statuses={statuses}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSortChange={handleSortChange}
          onStatusChange={handleStatusChange}
          meta={paginationMeta ?? undefined}
          onPageChange={setPage}
          limit={limit}
          onLimitChange={setLimit}
        />
      </div>
    </AdminLayout>
  );
}
